const IMAGES = require('./images');

module.exports = {
  IMAGES
};
